import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
import { ISelectDropdownActions } from '../types';

interface IDropdownControllerData {
  open: boolean;
  actions: ISelectDropdownActions;
}

export function useDropdownController(): IDropdownControllerData {
  const [open, setOpen] = React.useState(false);

  const openDropdown = () => setOpen(true);

  const closeDropdown = () => setOpen(false);

  const toggleDropdown = () => setOpen(!open);

  useUpdateEffect(() => {
    closeDropdown();
  }, []);

  return {
    open,
    actions: {
      openDropdown,
      closeDropdown,
      toggleDropdown,
    },
  };
}
